var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOrganizationDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_586",
    "data-name": "Union 586",
    d: "M7.4,20H.7a.7.7,0,1,1,0-1.4h.7V6a1,1,0,0,1,1-1H6V2A2,2,0,0,1,8,0h4a2,2,0,0,1,2,2V5h3.6a1,1,0,0,1,1,1V18.6h.7a.7.7,0,1,1,0,1.4ZM14,18.6h3.2V6.4H14v2h1.3a.7.7,0,0,1,0,1.4H14v2h1.3a.7.7,0,0,1,0,1.4H14Zm-1.4,0V2a.6.6,0,0,0-.6-.6H8a.6.6,0,0,0-.6.6V5.96c0,.013,0,.027,0,.04V18.6H9.3V15.9a.7.7,0,0,1,1.4,0v2.7h1.9Zm-9.8,0H6V13.2H4.7a.7.7,0,1,1,0-1.4H6v-2H4.7a.7.7,0,0,1,0-1.4H6v-2H2.8Zm5.9-5.4a.7.7,0,0,1,0-1.4h2.6a.7.7,0,1,1,0,1.4Zm0-3.4a.7.7,0,1,1,0-1.4h2.6a.7.7,0,1,1,0,1.4Zm0-3.4A.7.7,0,0,1,8.7,5h2.6a.7.7,0,0,1,0,1.4Z",
    fill: "#f8f8f8",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrganizationDark);
export default __webpack_public_path__ + "static/media/icon-organization_dark.782668c88e93fda8625a93c485744b70.svg";
export { ForwardRef as ReactComponent };